import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

const EPContainer = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    containerStyles,
    ...props
  } = _ref;
  const CENTERED_CONTENT_WIDTH = 1040;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    height: "100%",
    margin: {
      md: '0 auto'
    }
  }, containerStyles), /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: ref,
    bg: "slate0",
    display: {
      base: 'flex',
      md: 'grid'
    },
    flexDirection: {
      base: 'column',
      md: 'initial'
    },
    gridGap: {
      md: 'space60'
    },
    gridTemplateColumns: {
      md: 'minmax(255px, 305px) minmax(441px, 711px)'
    },
    maxWidth: CENTERED_CONTENT_WIDTH,
    minHeight: "100%",
    mx: {
      base: 'space50',
      md: 'space60'
    },
    py: {
      base: 'space50',
      md: 'space60'
    }
  }, props)));
});

export { EPContainer };
